import RestClient from './RestClient';
import { Font } from '../../models';

class Fonts extends RestClient {
    constructor() {
        super({
            "model": Font,
            "entryPoint": "font",
            "resource": "font",
            "resources": "fonts",
            "id_field": "_id",
            "sortBy": "name"
        });
    }

    get(_id) {
        throw new Error('Not allowed');
    }

    create(_payload) {
        throw new Error('Not allowed');
    }

    update(_payload) {
        throw new Error('Not allowed');
    }

    duplicate(_payload) {
        throw new Error('Not allowed');
    }

    delete(_id) {
        throw new Error('Not allowed');
    }
}

const FontsApi = new Fonts();

export default FontsApi;
